// extracted by mini-css-extract-plugin
module.exports = {"main":"ClassPack_main__IVr3C","cards":"ClassPack_cards__3k8-C"};